import styled from 'styled-components';

export const StyledVisitHistoryShowAnnulledCheckbox = styled.div`
   display: flex;
   align-items: flex-end;
   width: 156px;
   white-space: nowrap;
`;
StyledVisitHistoryShowAnnulledCheckbox.displayName = 'StyledVisitHistoryShowAnnulledCheckbox';
